export enum Direction {
    RIGHT, LEFT, UP, DOWN, INVALID
}

export interface Position {
    x: number;
    y: number;
}
